import { object } from 'prop-types';
import { getCurrentRole } from 'src/services/Roles/Merchants';

const ALLOWED = '1';
const DENIED = '0';
const NOT_SET = '';

export const AUTH_KEY = {
  name: 'name',
  org: 'org',
  booth_picker: 'booth_picker',
  dashboard: 'dashboard',
  summary: 'summary',
  transactions: 'transactions',
  transactions_detail: 'transactions_detail',
  daily_recap: 'daily_recap',
  daily_recap_details: 'daily_recap_details',
  voucher_usage: 'voucher_usage',
  voucher_usage_details: 'voucher_usage_details',
  reviews: 'reviews',
  reviews_detail: 'reviews_detail',
  branch_analytics: 'branch_analytics',
  booths: 'booths',
  booth_actions: 'booth_actions',
  merchant: 'merchant',
  merchant_actions: 'merchant_actions',
  xendit_mapping: 'xendit_mapping',
  cash_and_bank: 'cash_and_bank',
  cash_and_bank_details: 'cash_and_bank_details',
  account_chart: 'account_chart',
  account_chart_details: 'account_chart_details',
  accounting_transactions: 'accounting_transactions',
  accounting_transactions_details: 'accounting_transactions_details',
  frames: 'frames',
  frames_assignment: 'frames_assignment',
  incident_reports: 'incident_reports',
  incident_reports_action: 'incident_reports_action',
  vouchers: 'vouchers',
  vouchers_action: 'vouchers_action',
  bulk_vouchers: 'bulk_vouchers',
  bulk_vouchers_action: 'bulk_vouchers_action',
  paper_trackers: 'paper_trackers',
  paper_trackers_action: 'paper_trackers_action',
  export_reports: 'export_reports',
  role_setting: 'role_setting',
  users: 'users',
  users_action: 'users_action',
  refunds: 'refunds',
  refund_actions: 'refund_actions',
  reconciliation: 'reconciliation',
  product_category: 'product_category',
  product_category_action: 'product_category_action',
  product: 'product',
  product_action: 'product_action',
  warehouse: 'warehouse',
  warehouse_action: 'warehouse_action',
  product_tracker: 'product_tracker',
  marketing_activation: 'marketing_activation',
  marketing_activation_action: 'marketing_activation_action',
  direct_transaction_list: 'direct_transaction_list',
  pending_email: 'pending_email',
  pending_email_action: 'pending_email_action',
  direct_transaction_detail: 'direct_transaction_detail',
  event: 'event',
  event_action: 'event_action'
};

class Authentication {
  role = {
    name: '',
    org: '',
    booth_picker: '',
    dashboard: '',
    summary: '',
    transactions: '',
    transactions_detail: '',
    daily_recap: '',
    daily_recap_details: '',
    voucher_usage: '',
    voucher_usage_details: '',
    reviews: '',
    reviews_detail: '',
    branch_analytics: '',
    booths: '',
    booth_actions: '',
    merchant: '',
    merchant_actions: '',
    xendit_mapping: '',
    cash_and_bank: '',
    cash_and_bank_details: '',
    account_chart: '',
    account_chart_details: '',
    accounting_transactions: '',
    accounting_transactions_details: '',
    frames: '',
    frames_assignment: '',
    incident_reports: '',
    incident_reports_action: '',
    vouchers: '',
    vouchers_action: '',
    bulk_vouchers: '',
    bulk_vouchers_action: '',
    paper_trackers: '',
    paper_trackers_action: '',
    export_reports: '',
    role_setting: '',
    users: '',
    users_action: '',
    refunds: '',
    refund_actions: '',
    reconciliation: '',
    product_category: '',
    product_category_action: '',
    product: '',
    product_action: '',
    warehouse: '',
    warehouse_action: '',
    product_tracker: '',
    event: '',
    event_action: '',
    direct_transaction_list: '',
    direct_transaction_detail: '',
    pending_email: '',
    pending_email_action: '',
  };

  async fetchPermissions() {
    await getCurrentRole().then((response) => {
      if (response.success == 1) {
        if (response.userDeletedAt != null) {
        } else {
          Object.keys(AUTH_KEY).forEach((attr) => {
            this.role[AUTH_KEY[attr]] = response.data[AUTH_KEY[attr]];
          });
        }
      }
    });
  }

  isEmpty() {
    return this.role.name == '';
  }

  isAllowed(permission) {
    return permission == ALLOWED;
  }

  isDenied(permission) {
    return permission == DENIED || permission == NOT_SET;
  }
}

export default Authentication;
